import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    other: 'Other',
    percentage: '{0}%',
  },
  fr: {
    other: 'Autre',
    percentage: '{0}\xA0%',
  },
} as const);

export default locales;
